import $share from '@/api/modules/share'
import { AsyncRequest } from '@/utils/request'

/**
 * 页面参数
 */
const state = {
  shareAuth: 0,
  shareList: [],
  inviteShare: {},
  callInfo: {

  }
}
const getters = {
  shareAuth: (state) => state.shareAuth,
  callInfo: (state) => state.callInfo,
  share: (state) => state.inviteShare,
  shareList: (state) => state.shareList
}

const mutations = {
  setShareActiveDetail: (state, info) => {
    const { inviteShare } = info
    state.callInfo = info
    state.inviteShare = inviteShare
    state.shareList = inviteShare.shareList || []
  }
}

const actions = {
  // 获取分享活动详情
  inviteShare({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $share.inviteShare(data),
      resolve: (info) => commit('setShareActiveDetail', info)
    })
  },

  // 是否有邀请权限
  userAuth({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $share.userAuth(data),
      resolve: () => {},
      reject: () => {} // 前台处理
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
